import { Editor } from 'roosterjs-editor-core';
import EditorViewState from '../store/schema/EditorViewState';
import Undo from '../internalPlugin/Undo';

// Helper function in operateContent for the HTML, editor not yet initialized case
// Created primarily for testing
export default function createTempHtmlEditor(viewState: EditorViewState) {
    const contentDiv = document.createElement('div');
    return new Editor(contentDiv, {
        initialContent: viewState.content,
        undo: new Undo(viewState),
    });
}
